/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { USER_MY_PROJECTS } from "../../service/apiUrl";
import { postApiCall } from "../../service/PostApiCall";
import { Skeleton } from "../../components/Skeleton";

/* ============================================================================
   My Projects — an employee's live projects (developer or manager on them).

   Reveal, after Fluid Functionalism's `reveal-product`: the page's blocks
   fade in 0.06s apart on load and nothing moves on scroll. The grid is a
   `reveal-swap`: the skeleton tiles render first, the real tiles are added
   after them when the list lands, and with `reveal-items` on both each
   skeleton tile hands over to its real tile a step apart. The skeleton tile
   is built to the real tile's size so the swap never shifts the layout.
   ========================================================================== */
const SKELETON_TILES = 6;

const ProjectTile = ({ project }) => (
  <Link to={`/my-projects/${project.id}`} className="mp-tile">
    <span className="mp-tile-head">
      <span className="mp-tile-name">{project.name}</span>
      <span className="mp-tile-role">{project.role}</span>
    </span>
    <span className="mp-tile-tech">
      {project.technology.length ? project.technology.join(" · ") : "No technology listed"}
    </span>
    <span className="mp-tile-meta">
      {project.team_size} {project.team_size === 1 ? "person" : "people"}
      {project.updated_at ? ` · updated ${moment.unix(project.updated_at).fromNow()}` : ""}
    </span>
  </Link>
);

const TileSkeleton = () => (
  <span className="mp-tile" aria-hidden="true">
    <span className="mp-tile-head">
      <Skeleton width="55%" height={14} />
      <Skeleton width={64} height={20} radius={999} />
    </span>
    <Skeleton width="70%" height={12} />
    <Skeleton width="45%" height={12} />
  </span>
);

const MyProjects = (props) => {
  const token = useSelector((state) => state.signinReducers)?.data?.access_token;
  const [projects, setProjects] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!token) return;
    postApiCall({}, token, USER_MY_PROJECTS)
      .then((result) => setProjects(Array.isArray(result) ? result : []))
      .catch((error) => {
        console.error("MY_PROJECTS", error);
        setFailed(true);
        setProjects([]);
      });
  }, [token]);

  return (
    <div className={props?.data?.transtion === true ? "contents" : "content"}>
      <div className="content-top-spacer"></div>
      <div className="color-body manage reveal-product">
        <div className="page-head">
          <div className="page-eyebrow">Work</div>
          <h1 className="page-title">My Projects</h1>
        </div>

        <div className="reveal-swap" aria-busy={projects === null}>
          <div className="mp-grid reveal-items" aria-hidden="true">
            {Array.from({ length: SKELETON_TILES }, (_, i) => (
              <TileSkeleton key={i} />
            ))}
          </div>
          {projects !== null ? (
            projects.length ? (
              <div className="mp-grid reveal-items">
                {projects.map((project) => (
                  <ProjectTile key={project.id} project={project} />
                ))}
              </div>
            ) : (
              <div className="mp-empty">
                <span className="mp-empty-title">
                  {failed ? "Your projects could not be loaded" : "You're not on any projects yet"}
                </span>
                <span className="mp-empty-sub">
                  {failed
                    ? "Check your connection and reload the page."
                    : "When an admin adds you to a project, it shows up here."}
                </span>
              </div>
            )
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MyProjects;
